module.exports = __webpack_public_path__ + "img/BE0457370044.0aafb84a.png";